import { Component, OnInit } from '@angular/core';


@Component({
  standalone: false,
  selector: 'app-sourcefilecolumn',
  templateUrl: './sourcefilecolumn.component.html',
  styleUrls: ['./sourcefilecolumn.component.css'],

})

export class SourcefilecolumnComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
export class DemoAccordionBasicComponent {

  log(event: boolean) {

}
}
